import { Injectable } from '@angular/core';

// Services
import { ServiceBase } from '../service-base';

const CLASS_NAME = 'PaymentSchedule';
const ENDPOINT = `/payment-schedules/`;

@Injectable({
    providedIn: 'root'
})
export class PaymentScheduleService extends ServiceBase {
    constructor() {
        super(CLASS_NAME, ENDPOINT);
    }
}
